class HelloBarCookie {
	constructor(cookieName) {
		this.cookieName = cookieName;
	}

	get() {
		const v = document.cookie.match('(^|;) ?' + this.cookieName + '=([^;]*)(;|$)');

		return v ? v[2] : null;
	}

	set(value, days) {
		const d = new Date();

		d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

		// special handling to either set or not set a time with the cookie
		if (typeof days === 'undefined' || days == null) {
			// don't set a time
			document.cookie = this.cookieName + '=' + value + ';path=/;';
		} else {
			// set a time
			document.cookie = this.cookieName + '=' + value + ';path=/;expires=' + d.toGMTString();
		}
	}

	delete() {
		this.set('', -1);
	}
}

export default HelloBarCookie;
